import React from "react";
import { useFilterContext } from "../context/filter_context";
import styled from "styled-components";

const Sort = () => {
  const { filtered_products: products } = useFilterContext();

  return (
    <Wrapper>
      <p className="count">
        <span className="number">{products.length}</span>{" "}
        {products.length === 1 ? "produkt nalezen" : "produktů nalezeno"}
      </p>
      <div className="divider" />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin-bottom: 1.5rem;
  .count {
    margin: 0 0 0.75rem;
    color: var(--clr-charcoal-3);
    font-family: var(--ff-display);
    font-size: 1.1rem;
  }
  .number {
    color: var(--clr-accent-dark);
    font-weight: 700;
  }
  .divider {
    height: 1px;
    background: var(--clr-divider);
    width: 100%;
  }
`;

export default Sort;
